import React from 'react';
import './AllSetModal.pcss';
import { ModalInstanceProps } from '../interfaces';
import BasicModalTemplate from '../BasicModalTemplate';
import { OpenAllSetModalProps } from '@mm/state/modules/modalsState/actions';

type Props = ModalInstanceProps & OpenAllSetModalProps;

const AllSetModal = (props: Props) => {
  const { message } = props;
  return (
    <BasicModalTemplate
      className="all-set-modal"
      withMonkeyBackground={false}
      iconClass="all-set-modal__close-icon"
    >
      <div className="all-set-modal__header">
        <div className="all-set-modal__checkmark">
          <i className="fas fa-check-circle" />
        </div>
        <div className="all-set-modal__header-text">
          Overage payments enabled
        </div>
      </div>
      <div className="all-set-modal__message">{message}</div>
    </BasicModalTemplate>
  );
};

export default AllSetModal;
